import {AfterViewChecked, Directive, OnDestroy, TemplateRef} from '@angular/core';
import {PageLayoutService} from '../../../../../../../services/menu/page-layout.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[pageButtons]',
})
export class PageButtonsDirective implements OnDestroy, AfterViewChecked {
  constructor(public buttons: TemplateRef<any>, private navbarRightService: PageLayoutService) {}

  ngAfterViewChecked() {
    this.navbarRightService.headerRightRef = this.buttons;
  }

  ngOnDestroy() {
    this.navbarRightService.headerRightRef = null;
  }
}
